import { forwardRef, memo } from 'react';
import { SvgIcon } from '@material-ui/core';

export const ContentImprover = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 115 110"
        data-fill-none
      >
        <mask
          id="mask0_1529_12720"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="115"
          height="110"
        >
          <rect
            width="115"
            height="110"
            rx="8"
            fill="#D9D9D9"
          />
        </mask>
        <g mask="url(#mask0_1529_12720)">
          <rect
            x="-1"
            y="-1"
            width="117"
            height="112"
            rx="3.72141"
            fill="#ECF2FF"
          />
          <rect
            x="-0.406322"
            y="0.406322"
            width="40.6475"
            height="10.3586"
            rx="2.30249"
            transform="matrix(-1 0 0 1 59.0965 32.0015)"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="0.812643"
          />
          <rect
            x="38.4941"
            y="20.6248"
            width="16.2529"
            height="16.2529"
            rx="8.12643"
            fill="white"
          />
          <path
            d="M56.3723 28.4808C56.3723 33.717 52.1276 37.9617 46.8915 37.9617C41.6554 37.9617 37.4106 33.717 37.4106 28.4808C37.4106 23.2447 41.6554 19 46.8915 19C52.1276 19 56.3723 23.2447 56.3723 28.4808ZM39.5339 28.4808C39.5339 32.5443 42.828 35.8385 46.8915 35.8385C50.955 35.8385 54.2491 32.5443 54.2491 28.4808C54.2491 24.4173 50.955 21.1232 46.8915 21.1232C42.828 21.1232 39.5339 24.4173 39.5339 28.4808Z"
            fill="#E2E2E2"
          />
          <path
            d="M46.8915 20.1264C46.8915 19.5043 47.3975 18.9931 48.0152 19.0668C49.1706 19.2047 50.2939 19.5546 51.3279 20.102C52.6946 20.8257 53.8636 21.8727 54.7329 23.1518C55.6022 24.4309 56.1454 25.9033 56.3151 27.4405C56.4848 28.9777 56.2759 30.533 55.7065 31.971C55.1372 33.4089 54.2248 34.6857 53.0488 35.6901C51.8728 36.6945 50.469 37.396 48.9597 37.7334C47.4504 38.0707 45.8815 38.0337 44.3897 37.6257C43.2613 37.3169 42.2029 36.803 41.2663 36.1126C40.7656 35.7435 40.7466 35.0245 41.1725 34.571C41.5983 34.1175 42.3072 34.1037 42.8213 34.454C43.4799 34.9028 44.2105 35.2411 44.9842 35.4527C46.1215 35.7638 47.3176 35.792 48.4682 35.5348C49.6189 35.2776 50.6892 34.7428 51.5857 33.9771C52.4823 33.2114 53.1779 32.2379 53.612 31.1417C54.046 30.0454 54.2053 28.8596 54.0759 27.6877C53.9465 26.5157 53.5324 25.3932 52.8697 24.4181C52.2069 23.4429 51.3157 22.6446 50.2737 22.0929C49.5648 21.7176 48.8007 21.4641 48.0133 21.3404C47.3988 21.2438 46.8915 20.7485 46.8915 20.1264Z"
            fill="#FFB700"
          />
          <path
            d="M45.5793 25.9917H45.6904V26.7213H45.6274C45.3089 26.7213 45.0337 26.7706 44.8016 26.8694C44.572 26.9682 44.3831 27.1039 44.2349 27.2768C44.0868 27.4496 43.9757 27.6521 43.9016 27.8841C43.83 28.1138 43.7942 28.3582 43.7942 28.6174V29.4655C43.7942 29.6803 43.8177 29.8704 43.8646 30.0358C43.9115 30.1988 43.9769 30.3358 44.0609 30.4469C44.1473 30.5556 44.2461 30.6383 44.3572 30.6951C44.4683 30.7518 44.588 30.7802 44.7164 30.7802C44.8497 30.7802 44.9707 30.7531 45.0793 30.6988C45.188 30.642 45.2806 30.5642 45.3571 30.4654C45.4336 30.3667 45.4916 30.2494 45.5312 30.1136C45.5707 29.9778 45.5904 29.8297 45.5904 29.6692C45.5904 29.5161 45.5707 29.3729 45.5312 29.2396C45.4941 29.1038 45.4386 28.9853 45.3645 28.8841C45.2904 28.7804 45.1978 28.7001 45.0867 28.6434C44.9781 28.5841 44.8522 28.5545 44.709 28.5545C44.5312 28.5545 44.3695 28.5964 44.2238 28.6804C44.0806 28.7643 43.9646 28.8742 43.8757 29.01C43.7893 29.1433 43.7424 29.2853 43.735 29.4359L43.3943 29.3248C43.414 29.0952 43.4646 28.889 43.5461 28.7063C43.63 28.5236 43.7399 28.3681 43.8757 28.2397C44.0115 28.1113 44.1683 28.0138 44.346 27.9471C44.5263 27.878 44.7238 27.8434 44.9386 27.8434C45.2003 27.8434 45.4275 27.8928 45.62 27.9915C45.8126 28.0903 45.9719 28.2249 46.0978 28.3952C46.2262 28.5631 46.3212 28.7557 46.3829 28.973C46.4471 29.1878 46.4792 29.4124 46.4792 29.647C46.4792 29.9062 46.4397 30.1482 46.3607 30.3729C46.2817 30.5951 46.1657 30.7901 46.0126 30.958C45.862 31.1259 45.6781 31.2568 45.4608 31.3506C45.246 31.4444 45.0016 31.4913 44.7275 31.4913C44.4386 31.4913 44.1806 31.4358 43.9535 31.3247C43.7288 31.2135 43.5375 31.0605 43.3794 30.8654C43.2239 30.6704 43.1054 30.4457 43.0239 30.1914C42.9424 29.9371 42.9017 29.668 42.9017 29.384V29.0137C42.9017 28.6038 42.9535 28.2175 43.0572 27.8545C43.1609 27.4891 43.3202 27.1669 43.535 26.8879C43.7523 26.6089 44.03 26.3904 44.3683 26.2324C44.7065 26.0719 45.1102 25.9917 45.5793 25.9917ZM50.8086 30.7062V31.4172H47.194V30.8062L48.9494 28.8915C49.142 28.6742 49.2939 28.4866 49.405 28.3286C49.5161 28.1705 49.5938 28.0286 49.6383 27.9027C49.6852 27.7743 49.7086 27.6496 49.7086 27.5286C49.7086 27.3583 49.6765 27.2089 49.6124 27.0805C49.5506 26.9496 49.4593 26.8472 49.3383 26.7731C49.2173 26.6966 49.0704 26.6583 48.8976 26.6583C48.6976 26.6583 48.5297 26.7015 48.3939 26.7879C48.2581 26.8743 48.1557 26.9941 48.0865 27.1472C48.0174 27.2978 47.9828 27.4706 47.9828 27.6656H47.0903C47.0903 27.3521 47.1619 27.0657 47.3051 26.8064C47.4483 26.5447 47.6557 26.3373 47.9273 26.1843C48.1989 26.0287 48.526 25.9509 48.9087 25.9509C49.2692 25.9509 49.5753 26.0114 49.8272 26.1324C50.079 26.2534 50.2703 26.425 50.4012 26.6472C50.5345 26.8694 50.6012 27.1323 50.6012 27.436C50.6012 27.6039 50.574 27.7706 50.5197 27.936C50.4654 28.1014 50.3876 28.2668 50.2864 28.4323C50.1876 28.5952 50.0703 28.7594 49.9346 28.9248C49.7988 29.0878 49.6494 29.2532 49.4864 29.4211L48.3199 30.7062H50.8086Z"
            fill="#1E1E1E"
          />
          <rect
            width="15.1489"
            height="1.59589"
            rx="0.541762"
            transform="matrix(-1 0 0 1 37.1855 37.9868)"
            fill="#1E1E1E"
          />
          <rect
            width="7.97311"
            height="1.59589"
            rx="0.541762"
            transform="matrix(-1 0 0 1 30.0098 35.5928)"
            fill="#1E1E1E"
          />
          <rect
            width="7.97311"
            height="1.59589"
            rx="0.541762"
            transform="matrix(-1 0 0 1 39.5776 35.5928)"
            fill="#1E1E1E"
          />
          <rect
            x="-0.406322"
            y="0.406322"
            width="75.0338"
            height="19.6238"
            rx="2.30249"
            transform="matrix(-1 0 0 1 104.626 48.7966)"
            fill="white"
            stroke="#1E1E1E"
            strokeWidth="0.812643"
          />
          <rect
            width="27.7131"
            height="2.91949"
            rx="0.541762"
            transform="matrix(-1 0 0 1 63.8691 59.7446)"
            fill="#1E1E1E"
          />
          <rect
            width="14.5859"
            height="2.91949"
            rx="0.541762"
            transform="matrix(-1 0 0 1 50.7427 55.3645)"
            fill="#1E1E1E"
          />
          <rect
            width="14.5859"
            height="2.91949"
            rx="0.541762"
            transform="matrix(-1 0 0 1 68.2451 55.3645)"
            fill="#1E1E1E"
          />
          <path
            d="M64.9053 39.9253L68.6299 43.6499L72.3545 39.9253"
            stroke="#1E1E1E"
            strokeWidth="0.812643"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M60.4355 31.7312H65.65C66.4403 31.7312 67.1982 32.0451 67.757 32.6039C68.3158 33.1627 68.6297 33.9206 68.6297 34.7109V43.65"
            stroke="#1E1E1E"
            strokeWidth="0.812643"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect
            x="81.8354"
            y="58.0066"
            width="16.2529"
            height="16.2529"
            rx="8.12643"
            fill="white"
          />
          <path
            d="M97.6042 70.4716C98.1175 70.7549 98.7694 70.57 98.9936 70.0282C99.8041 68.0693 99.9383 65.8839 99.3559 63.8243C98.6768 61.4224 97.0778 59.3852 94.906 58.1548C92.7342 56.9245 90.1648 56.6003 87.7554 57.2525C85.346 57.9047 83.2911 59.4808 82.0365 61.6387C80.7819 63.7966 80.429 66.3622 81.0542 68.7787C81.6794 71.1953 83.2324 73.2677 85.3761 74.5464C87.5199 75.825 90.0814 76.2067 92.5047 75.6085C94.5828 75.0956 96.4155 73.8977 97.7169 72.2242C98.0768 71.7614 97.9149 71.1034 97.4148 70.7974C96.9146 70.4915 96.2666 70.6551 95.8919 71.106C94.8933 72.3079 93.5308 73.1683 91.9959 73.5472C90.1153 74.0114 88.1274 73.7152 86.4638 72.7229C84.8001 71.7306 83.5949 70.1223 83.1097 68.2469C82.6245 66.3716 82.8984 64.3805 83.872 62.7059C84.8457 61.0312 86.4404 59.8081 88.3102 59.3019C90.18 58.7958 92.174 59.0474 93.8594 60.0022C95.5449 60.957 96.7858 62.538 97.3128 64.402C97.743 65.9233 97.6694 67.533 97.1189 68.9955C96.9124 69.5442 97.0909 70.1883 97.6042 70.4716Z"
            fill="#E2E2E2"
          />
          <path
            d="M90.2328 58.0495C90.2328 57.4274 90.7389 56.9162 91.3566 56.9899C93.207 57.2108 94.9604 57.9736 96.3901 59.1946C98.1067 60.6607 99.2438 62.6912 99.5969 64.9208C99.95 67.1504 99.496 69.4329 98.3165 71.3577C97.137 73.2824 95.3095 74.7232 93.1625 75.4208C91.0156 76.1183 88.6902 76.027 86.6046 75.1631C84.519 74.2992 82.8101 72.7195 81.7853 70.7081C80.7605 68.6968 80.4869 66.3857 81.0139 64.1907C81.4528 62.3625 82.423 60.7147 83.7902 59.4484C84.2466 59.0257 84.9565 59.1418 85.3222 59.645C85.6878 60.1483 85.5685 60.8472 85.1281 61.2866C84.1874 62.225 83.518 63.4104 83.2044 64.7166C82.8027 66.39 83.0112 68.152 83.7925 69.6854C84.5739 71.2189 85.8767 72.4232 87.4667 73.0818C89.0568 73.7404 90.8296 73.8101 92.4664 73.2782C94.1032 72.7464 95.4965 71.648 96.3957 70.1806C97.295 68.7132 97.6411 66.9731 97.3719 65.2732C97.1026 63.5734 96.2357 62.0254 94.927 60.9077C93.9056 60.0353 92.6673 59.4697 91.3547 59.2634C90.7401 59.1669 90.2328 58.6716 90.2328 58.0495Z"
            fill="#3AA97F"
          />
          <path
            d="M86.943 68.6374H87.017C87.3577 68.6374 87.6417 68.593 87.8688 68.5041C88.0984 68.4127 88.2811 68.2868 88.4169 68.1263C88.5527 67.9658 88.6503 67.777 88.7095 67.5597C88.7688 67.3424 88.7984 67.1066 88.7984 66.8523V65.9228C88.7984 65.703 88.7749 65.5105 88.728 65.345C88.6836 65.1771 88.6194 65.0377 88.5354 64.9265C88.454 64.813 88.3589 64.7278 88.2503 64.671C88.1441 64.6142 88.0293 64.5858 87.9059 64.5858C87.7701 64.5858 87.6479 64.6167 87.5392 64.6784C87.4331 64.7377 87.3429 64.8204 87.2689 64.9265C87.1973 65.0302 87.1417 65.1525 87.1022 65.2932C87.0652 65.4315 87.0467 65.5796 87.0467 65.7376C87.0467 65.8857 87.0639 66.0289 87.0985 66.1672C87.1355 66.303 87.1899 66.424 87.2615 66.5301C87.3331 66.6363 87.4232 66.7203 87.5318 66.782C87.6404 66.8437 87.7676 66.8746 87.9133 66.8746C88.0515 66.8746 88.1787 66.8486 88.2947 66.7968C88.4108 66.7425 88.512 66.6696 88.5984 66.5783C88.6848 66.4869 88.7527 66.3845 88.8021 66.2709C88.8515 66.1573 88.8786 66.0413 88.8836 65.9228L89.2243 66.0265C89.2243 66.2141 89.1848 66.3993 89.1058 66.582C89.0292 66.7622 88.9218 66.9276 88.7836 67.0783C88.6478 67.2264 88.4885 67.3449 88.3058 67.4338C88.1256 67.5227 87.9293 67.5671 87.717 67.5671C87.4602 67.5671 87.2331 67.519 87.0355 67.4227C86.8405 67.3239 86.6775 67.1906 86.5467 67.0227C86.4183 66.8548 86.322 66.6622 86.2578 66.445C86.1936 66.2277 86.1615 65.9993 86.1615 65.7598C86.1615 65.5006 86.201 65.2574 86.28 65.0302C86.359 64.8031 86.4739 64.6031 86.6245 64.4303C86.7751 64.255 86.9578 64.1192 87.1726 64.0229C87.3898 63.9241 87.6355 63.8748 87.9096 63.8748C88.2009 63.8748 88.4564 63.9316 88.6762 64.0451C88.8959 64.1587 89.0811 64.3155 89.2317 64.5155C89.3823 64.7155 89.4959 64.9475 89.5724 65.2117C89.6489 65.4759 89.6872 65.7598 89.6872 66.0635V66.3783C89.6872 66.6968 89.6588 67.0042 89.602 67.3005C89.5453 67.5943 89.4527 67.8671 89.3243 68.1189C89.1984 68.3683 89.0317 68.588 88.8243 68.7781C88.6194 68.9658 88.3676 69.1127 88.0688 69.2189C87.7725 69.3225 87.4244 69.3744 87.0244 69.3744H86.943V68.6374ZM94.0499 66.1931V67.0746C94.0499 67.4967 94.0079 67.8572 93.924 68.156C93.8425 68.4522 93.724 68.693 93.5684 68.8781C93.4129 69.0633 93.2265 69.1991 93.0092 69.2855C92.7944 69.3719 92.5537 69.4151 92.287 69.4151C92.0747 69.4151 91.8772 69.388 91.6945 69.3337C91.5143 69.2793 91.3513 69.1942 91.2056 69.0781C91.06 68.9621 90.9353 68.8127 90.8316 68.63C90.7304 68.4448 90.6514 68.2239 90.5946 67.9671C90.5402 67.7103 90.5131 67.4128 90.5131 67.0746V66.1931C90.5131 65.7685 90.5551 65.4105 90.639 65.1191C90.723 64.8253 90.8427 64.5871 90.9982 64.4044C91.1538 64.2192 91.339 64.0846 91.5538 64.0007C91.771 63.9167 92.013 63.8748 92.2796 63.8748C92.4944 63.8748 92.692 63.9019 92.8722 63.9562C93.0549 64.0081 93.2178 64.0908 93.361 64.2044C93.5067 64.3179 93.6302 64.4661 93.7314 64.6488C93.8351 64.829 93.9141 65.0475 93.9684 65.3043C94.0227 65.5586 94.0499 65.8549 94.0499 66.1931ZM93.1574 67.2005V66.0598C93.1574 65.845 93.145 65.6561 93.1203 65.4932C93.0956 65.3278 93.0586 65.1883 93.0092 65.0747C92.9623 64.9586 92.9031 64.8648 92.8315 64.7932C92.7599 64.7192 92.6784 64.6661 92.587 64.634C92.4957 64.5994 92.3932 64.5821 92.2796 64.5821C92.1414 64.5821 92.0179 64.6093 91.9093 64.6636C91.8007 64.7155 91.7093 64.7994 91.6352 64.9154C91.5612 65.0315 91.5044 65.1846 91.4649 65.3747C91.4278 65.5623 91.4093 65.7907 91.4093 66.0598V67.2005C91.4093 67.4177 91.4217 67.6091 91.4464 67.7745C91.471 67.9399 91.5081 68.0819 91.5575 68.2004C91.6068 68.3164 91.6661 68.4127 91.7352 68.4893C91.8068 68.5633 91.8883 68.6177 91.9797 68.6522C92.0735 68.6868 92.1759 68.7041 92.287 68.7041C92.4278 68.7041 92.5525 68.6769 92.6611 68.6226C92.7697 68.5683 92.8611 68.4819 92.9351 68.3634C93.0092 68.2424 93.0648 68.0856 93.1018 67.893C93.1388 67.7004 93.1574 67.4696 93.1574 67.2005Z"
            fill="#1E1E1E"
          />
          <path
            d="M11.7441 71.3542L12.6627 72.9091"
            stroke="#191919"
            strokeWidth="0.902937"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.9811 71.672L11.4263 72.5906"
            stroke="#191919"
            strokeWidth="0.902937"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.97559 78.3008L10.8941 79.8556"
            stroke="#191919"
            strokeWidth="0.902937"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.2125 78.619L9.65771 79.5376"
            stroke="#191919"
            strokeWidth="0.902937"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.6216 80.116C17.6216 80.116 20.4233 81.8565 22.3283 80.7311L24.7715 78.9114L22.1272 74.4355L19.3764 75.7345C17.6133 76.7756 17.6216 80.116 17.6216 80.116Z"
            fill="#FF5A4F"
            stroke="#1E1E1E"
            strokeWidth="0.812643"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M25.9582 69.297C23.3787 66.3576 17.8964 65.7248 16.7688 68.8177C16.7029 68.9986 16.7657 69.2013 16.9126 69.3507L21.3891 73.9046"
            fill="#FFEDBF"
          />
          <path
            d="M25.9582 69.297C23.3787 66.3576 17.8964 65.7248 16.7688 68.8177C16.7029 68.9986 16.7657 69.2013 16.9126 69.3507L21.3891 73.9046"
            stroke="#1E1E1E"
            strokeWidth="0.812643"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M30.9221 77.7024C32.2403 81.3481 30.1988 86.3989 26.9925 85.9943C26.753 85.9641 26.5665 85.788 26.5033 85.5764L24.6816 79.4809"
            fill="#FFEDBF"
          />
          <path
            d="M30.9221 77.7024C32.2403 81.3481 30.1988 86.3989 26.9925 85.9943C26.753 85.9641 26.5665 85.788 26.5033 85.5764L24.6816 79.4809"
            stroke="#1E1E1E"
            strokeWidth="0.812643"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M21.3923 73.8904L24.6976 79.4853C28.8063 78.2684 33.3847 77.2439 35.7244 75.8047C40.0253 73.2638 39.9788 68.4502 39.8762 67.1161C39.8587 66.8889 39.7308 66.6819 39.5206 66.5453C38.3585 65.7903 34.2004 63.4897 29.9369 66.0085C27.5474 67.3632 24.4197 70.8914 21.3923 73.8904Z"
            fill="#FFB700"
            stroke="#1E1E1E"
            strokeWidth="0.812643"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M34.3613 72.7488C35.6389 71.9941 36.0627 70.3466 35.3079 69.069C34.5532 67.7915 32.9057 67.3677 31.6281 68.1224C30.3506 68.8772 29.9268 70.5247 30.6815 71.8022C31.4363 73.0797 33.0838 73.5036 34.3613 72.7488Z"
            fill="#91B6FF"
            stroke="#1E1E1E"
            strokeWidth="0.812643"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M25.6104 62.6902C25.6718 62.6539 25.7452 62.6434 25.8144 62.6612C25.8836 62.679 25.9429 62.7236 25.9792 62.7851"
            stroke="#191919"
            strokeWidth="0.902937"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M25.5159 63.0588C25.4796 62.9973 25.4691 62.9239 25.4869 62.8547C25.5047 62.7855 25.5493 62.7263 25.6108 62.6899"
            stroke="#191919"
            strokeWidth="0.902937"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M25.8845 63.153C25.823 63.1894 25.7496 63.1998 25.6804 63.182C25.6112 63.1642 25.552 63.1196 25.5156 63.0581"
            stroke="#191919"
            strokeWidth="0.902937"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M25.9789 62.7847C26.0153 62.8462 26.0257 62.9196 26.0079 62.9888C25.9901 63.058 25.9456 63.1172 25.8841 63.1535"
            stroke="#191919"
            strokeWidth="0.902937"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </SvgIcon>
    );
  })
);
